


















import {Prop, Vue} from "vue-property-decorator";
import Component from "vue-class-component";
import Static from "@/components/dashboard/widgets/Static.vue";
import Link from "@/components/dashboard/widgets/Link.vue";
import ImageLink from "@/components/dashboard/widgets/ImageLink.vue";
import ContactLink from "@/components/dashboard/widgets/ContactLink.vue";
import Weather from "@/components/dashboard/widgets/Weather.vue";
import Carousel from "@/components/dashboard/widgets/Carousel.vue";
import Actus from "@/components/dashboard/widgets/Actus.vue";
import VisualBi from "@/components/dashboard/widgets/VisualBi.vue";
import ImageContainer from "@/components/dashboard/widgets/ImageContainer.vue";
import M3QuickLogin from "@/components/dashboard/widgets/M3QuickLogin.vue";
import {GridProfile} from "@/modules/GridProfile";
import ImageDynamicLinkReport from "@/components/dashboard/widgets/ImageDynamicLinkReport.vue";

export interface Style {
    title?: {
        color: string;
        fontSize: string;
        backgroundColor: string;
    };
    container?: {
        color: string;
        backgroundColor: string;
    };
    backgroundColor?: string;
    display?: string;
    padding?: string | number;
}

export interface Item {
    image?: string;
    title?: string;
    icon?: string;
    news: {
        title?: string;
        text?: string;
    };
    link?: string;
}

export interface WidgetParameters {
    title?: string;
    message?: string;
    email?: string;
    num?: string;
    style?: Style;
    carousel: Item;
    actus: Item;
}
export interface Widget {
    area: string;
    type: string;
    parameters: WidgetParameters;
}

const components = {
    Static,
    Link,
    ImageLink,
    Weather,
    ContactLink,
    VisualBi,
    ImageContainer,
    Carousel,
    Actus,
    M3QuickLogin,
    ImageDynamicLinkReport,
};
@Component({components})

export default class Dashboard extends Vue {
    @Prop() public profile!: GridProfile;

    protected gridSize: string = "lg";

    protected mounted() {
        this.onResize();
        this.$nextTick(() => {
            window.addEventListener("resize", this.onResize);
        });
    }

    protected beforeDestroy() {
        window.removeEventListener("resize", this.onResize);
    }

    protected onResize() {
        if (1200 <= window.innerWidth) {
            this.gridSize = "lg";
        } else if (992 >= window.innerWidth) {
            this.gridSize = "sm";
        } else {
            this.gridSize = "md";
        }
    }

    public get computedGridStyle(): object {
        const gridSize = this.gridSize as keyof GridProfile["grids"];
        // Compute merged rows size, columns size and areas
        let gridTemplateAreas = "";
        let gridTemplateRows = "";
        const rowsRegex = /"((\w+\s?)+)"/g;
        const rows = rowsRegex[Symbol.matchAll](this.profile.grids[gridSize]);
        let lastRow = "";
        let countMaxColumn = 1;
        let countSameRow = 1;
        Array.from(rows).forEach((row: RegExpMatchArray) => {
            if (lastRow === row[1]) {
                countSameRow++;
            } else {
                if (lastRow) {
                    gridTemplateAreas += `"${lastRow}" `;
                    gridTemplateRows += `${countSameRow}fr `;
                }
                countSameRow = 1;
            }
            countMaxColumn = Math.max(countMaxColumn, row[1].split(" ").length);
            lastRow = row[1];
        });
        gridTemplateAreas += `"${lastRow}" `;
        gridTemplateRows += `${countSameRow}fr `;
        const gridTemplateColumns = `repeat(${countMaxColumn}, 1fr)`;

        return {
            gridTemplateAreas,
            gridTemplateRows: "lg" === gridSize ? gridTemplateRows : "auto",
            gridTemplateColumns,
        };
    }

    protected checkExistInGridArea(widget: Widget): boolean {
        const gridSize = this.gridSize as keyof GridProfile["grids"];
        return this.profile.grids[gridSize].includes(widget.area);
    }
}
